import ES from './es';
import EN from './en';

const paymentLinksPosition = {
    ES,
    EN
};

export default paymentLinksPosition;
